import { render, staticRenderFns } from "./ExportOrders.vue?vue&type=template&id=1c700010&scoped=true&"
import script from "./ExportOrders.vue?vue&type=script&lang=js&"
export * from "./ExportOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c700010",
  null
  
)

export default component.exports